import { Injectable } from '@angular/core';
import { BillingStore } from '@app/interfaces/billing-store.interface';
import { Observable, BehaviorSubject, Subject } from 'rxjs';

export interface QuotePreparationCommand {
  action: 'start' | 'stop';
  title?: string;
  pollForStatus?: boolean;
  pollDelayMs?: number;
  targetQuoteStatus?: string;
  useLegacyRefreshWhenFlagOff?: boolean;
  immediateCheckOnStart?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class QuotePreparationService {
  private preparingCommandSubject: Subject<QuotePreparationCommand> = new Subject<QuotePreparationCommand>();
  private currentQuoteStatusSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

  preparingCommands$: Observable<QuotePreparationCommand> = this.preparingCommandSubject.asObservable();
  currentQuoteStatus$: Observable<string | null> = this.currentQuoteStatusSubject.asObservable();

  setIPGPreparing(
    title: string = 'Preparing Quote',
    options?: Pick<
      QuotePreparationCommand,
      'pollForStatus' | 'pollDelayMs' | 'targetQuoteStatus' | 'useLegacyRefreshWhenFlagOff' | 'immediateCheckOnStart'
    >
  ): void {
    this.preparingCommandSubject.next({ action: 'start', title, ...options });
  }

  stopIPGPreparing(): void {
    this.preparingCommandSubject.next({ action: 'stop' });
  }

  setCurrentQuoteStatus(status: string | null | undefined): void {
    this.currentQuoteStatusSubject.next(status ?? null);
  }

  getCurrentQuoteStatus(): string | null {
    return this.currentQuoteStatusSubject.getValue();
  }

  getQuoteStatus(policyStore: BillingStore | null | undefined): string | null {
    return policyStore?.policyData?.policy?.quoteStatus ?? null;
  }

  isQuoteInStatus(policyStore: BillingStore | null | undefined, targetQuoteStatus: string = 'QTD'): boolean {
    return this.getQuoteStatus(policyStore) === targetQuoteStatus;
  }

  isCurrentQuoteInStatus(targetQuoteStatus: string = 'QTD'): boolean {
    return this.getCurrentQuoteStatus() === targetQuoteStatus;
  }

  quoteReadyForEditOrProceed(policyStore: BillingStore, proceedPreQTDUntilBind: boolean = false): boolean {
    if (proceedPreQTDUntilBind && policyStore?.policyData?.policy) {
      return true;
    }

    return this.isQuoteInStatus(policyStore, 'QTD');
  }
}
